<div class="container container_no_spaces">
  <div class="row justify-content-center row-register2">
    <div class="col col-sm-10 col-md-8 col-lg-6 justify-content-center">
      <div class="container container_inner mt-3">
        <div class="form-group">
          <h4 class="text-blue">{{ 'DASHBOARD.CERTIFICATE_TITLE' | translate }}</h4>
        </div>
        <br />
        <button 
          type="button"
          class="btn btn-success btn-lg d-flex align-items-center justify-content-center"
          [disabled]="isDownloading || !existsCertificate()"
          (click)="downloadCertificate()"
          style="min-width: 200px; height: 45px;">
          
          <span *ngIf="!isDownloading" class="d-flex align-items-center">
            <i class="fa fa-download me-2"></i>
            {{ 'DASHBOARD.DOWNLOAD_CERTIFICATE' | translate }}
          </span>
          
          <span *ngIf="isDownloading" class="d-flex align-items-center">
            <span class="spinner-border spinner-border-sm me-2" role="status">
              <span class="visually-hidden">Loading...</span>
            </span>
            {{ 'DASHBOARD.GENERATING_CERTIFICATE' | translate }}
          </span>
        </button>
        <div class="mt-3 text-center" *ngIf="!existsCertificate()">
          <small class="text-muted">
            <i class="fa fa-info-circle me-1"></i>
            {{ 'DASHBOARD.CERTIFICATE_NOT_AVAILABLE' | translate }}
          </small>
        </div>
      </div>
    </div>
  </div>
</div>
